import { render } from "./AnnotationSidebar.vue?vue&type=template&id=c0543954&scoped=true"
import script from "./AnnotationSidebar.vue?vue&type=script&lang=js"
export * from "./AnnotationSidebar.vue?vue&type=script&lang=js"

import "./AnnotationSidebar.vue?vue&type=style&index=0&id=c0543954&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0543954"]])

export default __exports__